var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWheelchairAccessibility(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:currentBackgroundColor;}.cls-2{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M113.37,145.75l32.27-6.5,19.5,35.5h0a8.71,8.71,0,0,0,1.7,2,8.47,8.47,0,0,0,12-11.89l-26.21-46.19-30.34,6.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M137.35,142.21l8.29-3,19.5,35.5h0a8.71,8.71,0,0,0,1.7,2,8.47,8.47,0,0,0,12-11.89l-27.18-48.24-20,7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M113.46,104.42l16.34-27.1L106.08,61.85,74.37,55.33,46.26,79.11A8.58,8.58,0,0,0,52,94.79a8.42,8.42,0,0,0,5.35-2.94L77,74.44,95.73,79,83.92,97m62.24-53.66a14.78,14.78,0,1,1-16.6-12.89A14.87,14.87,0,0,1,146.16,43.37Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 86.69,
    cy: 148.05,
    r: 50.17
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWheelchairAccessibility);
export default __webpack_public_path__ + "static/media/WHEELCHAIR_ACCESSIBILITY.f81ec3c90af2ecc1bb3e973461ff2074.svg";
export { ForwardRef as ReactComponent };